module.exports = __webpack_public_path__ + "img/wall.53089a77.png";